import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const MainLogoWrapper = styled.svg`
  position: fixed;
  top: ${props => (props.displayMobile ? '40px' : '60px')};
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  width: ${props => (props.displayMobile ? '150px' : '200px')};
  g,
  path,
  polygon {
    transition: fill 300ms ease;
  }
`;

function MainLogo({ toggleActive, displayMobile }) {
  return (
    <Link to={'/'} onClick={toggleActive}>
      <MainLogoWrapper
        displayMobile={displayMobile}
        xmlns="http://www.w3.org/2000/svg"
        height="25"
        viewBox="0 0 200 25"
      >
        <title>Row Main Logo</title>
        <path
          id="A"
          d="M188.8,0h-5.2L172.23,25h6.23l2.62-5.73h10L193.64,25H200Zm-5.11,13.5,2.45-5.36,2.4,5.36Z"
          fill="#d9d9d9"
        />
        <path
          id="L"
          d="M103.83,0H91.73V25h12.19A10.1,10.1,0,0,0,112,21.62a13.78,13.78,0,0,0,3.68-9.21C115.68,5.46,110.47,0,103.83,0Zm4.65,17h0a6.49,6.49,0,0,1-1,1c-.11.09-.23.17-.35.25l-.05,0a5.17,5.17,0,0,1-1.12.58l-.14.05-.29.09-.26.07-.25.06-.35,0-.2,0c-.19,0-.38,0-.58,0H97.38V5.73h6.48c4.17,0,6.07,3.59,6.07,6.92A7,7,0,0,1,108.48,17.05Z"
          fill="#d9d9d9"
        />
        <polygon
          id="T"
          points="119.68 5.73 127.72 5.73 127.72 11.35 127.72 25 133.35 25 133.35 5.73 135.59 5.73 141.31 5.73 141.31 0.01 119.68 0.01 119.68 5.73"
          fill="#d9d9d9"
        />
        <polygon
          id="D"
          points="153.2 0.01 147.48 0.01 147.48 5.72 147.48 25 147.48 25 161.21 25 166.93 25 166.93 19.28 153.2 19.28 153.2 0.01"
          fill="#d9d9d9"
        />
        <polygon
          id="W"
          points="80.34 0 77.75 8.6 76.39 13.08 72.69 0.01 70.17 0.01 67.65 0.01 63.95 13.08 62.6 8.6 60.01 0 53.83 0 61.31 25 66.67 25 68.7 17.84 70.17 12.75 71.65 17.84 73.68 25 79.04 25 86.52 0 80.34 0"
          fill="#262626"
        />
        <path
          id="O"
          d="M39.2,0c-7,0-12.77,5.49-12.77,12.23a13.29,13.29,0,0,0,.28,2.7,12.54,12.54,0,0,0,10,9.84,12.81,12.81,0,0,0,2.42.23A12.6,12.6,0,0,0,51.93,12.59a12.42,12.42,0,0,0-3.74-9A12.76,12.76,0,0,0,39.2,0Zm4.52,17.83a7.29,7.29,0,0,1-4.53,1.54A7,7,0,0,1,32,12.6,6.9,6.9,0,0,1,33.65,8a7.13,7.13,0,0,1,5.52-2.38,6.83,6.83,0,0,1,4.55,12.2Z"
          fill="#262626"
        />
        <path
          id="R"
          d="M18.58,15c3.06-1.08,4.58-4.24,4.58-7.1C23.16,3.48,19.92,0,14.85,0H0V11.25H0V25H6V15.71h6.42l0,0L16.88,25h6.63ZM17,9.81a.5.5,0,0,1-.12.08h0a3.43,3.43,0,0,1-.51.24h0l-.23.07-.18,0-.06,0a5.87,5.87,0,0,1-.62.07H6v-5h8.87c3,0,3,1.78,3,2.36A2.36,2.36,0,0,1,17,9.81Z"
          fill="#262626"
        />
      </MainLogoWrapper>
    </Link>
  );
}

export default MainLogo;
